export const SEVERITY_STYLES = {
  Critical: { dot: "bg-[#FF3B30]", text: "text-[#FF3B30]", ring: "ring-[#FF3B30]/40" },
  High: { dot: "bg-[#FF9500]", text: "text-[#FF9500]", ring: "ring-[#FF9500]/40" },
  Medium: { dot: "bg-[#FFCC00]", text: "text-[#FFCC00]", ring: "ring-[#FFCC00]/40" },
  Low: { dot: "bg-[#007AFF]", text: "text-[#007AFF]", ring: "ring-[#007AFF]/40" },
};

export const STATUS_STYLES = {
  New: "text-[#007AFF] border-[#007AFF]/40",
  Reviewed: "text-[#FFCC00] border-[#FFCC00]/40",
  Resolved: "text-emerald-400 border-emerald-400/40",
};

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, {
      month: "short", day: "2-digit", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function formatDuration(s) {
  if (!s) return "0:00";
  const m = Math.floor(s / 60);
  const sec = String(s % 60).padStart(2, "0");
  return `${m}:${sec}`;
}
